import React from 'react'
import { IoIosCloseCircleOutline } from "react-icons/io";

const NotificationBarItem = ({children,setShow}) => {
    return (
        <div className='flex items-center justify-center bg-indigo-100 min-h-8 h-auto text-xs md:text-sm text-indigo-600 border-indigo-200 border-b px-2 overflow-x-hidden'>    
            <div className='flex-1 min-w-0 flex items-center justify-center text-center'>
                <div className='min-w-0 whitespace-normal break-words'>
                    {children}
                </div>
            </div>
            <IoIosCloseCircleOutline onClick={()=>setShow(false)} size={20} className='mx-3' />
        </div>
    )
}

export default NotificationBarItem
